<template>
<!-- 单一标题 -->
  <div class="single-title">
    <div class="subIcon">
      <span class="upIcon">{{titleNum}}</span>
    </div>
    <div class="subDetail" v-if='ofrom === "nohtml"'>
      <p class="fontDetail">{{title}}</p>
    </div>
    <div class="subDetail" v-if='ofrom === "yeshtml"'>
        <p class="fontDetail" v-html="title"></p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'SingleTitle',
  props: ['num', 'title', 'ofrom'],
  computed: {
    titleNum() {
      if (this.ofrom === 'yeshtml') {
        return this.num
      } else {
        return this.num + 1
      }
    }
  },
  mounted() {
    // console.log('singleTitle----', this.titleNum);
    // console.log('title====', this.title);
  }
}
</script>

<style lang="scss" scoped>
@import '~@/common/scss/const.scss';
@import '~@/common/scss/mixin.scss';

.single-title {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  font-family:PingFangSC-Semibold;
  @include display-flex;
  @include flex-direction(row);
  .subIcon {
    @include flex(0 0 21px);
    width: 21px;
    .upIcon {
      display: inline-block;
      width: 21px;
      height: 19px;
      background:red;
      background:url('./images/bgnum.png') no-repeat center center;
      background-size: 100% 100%;
      background-origin: center center;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      line-height: 22px;
      border-radius: 50%;
    }
  }
  .subDetail {
    @include flex(1);
    padding-left: 4px;
    .fontDetail {
      text-align: left;
      color: $color-font-title;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/SingleTitle/SingleTitle.vue